import type { OnboardingFlow } from "./events";
import { getCollabOnboarding } from "./collabOnboarding";
import { getFengShuiOnboarding } from "./fengShuiOnboarding";
import { getRender3dOnboarding } from "./render3dOnboarding";

/**
 * The first run the visitor is still in, or `null` once none is (never
 * entered, or the guide was skipped or finished). The flows are mutually
 * exclusive, so at most one matches.
 */
export function activeOnboardingFlow(): OnboardingFlow | null {
  const r3d = getRender3dOnboarding();
  if (r3d.active && !r3d.dismissed) return "render_3d";
  const fs = getFengShuiOnboarding();
  if (fs.active && !fs.dismissed) return "feng_shui";
  const collab = getCollabOnboarding();
  if (collab.active && !collab.dismissed) return "collab";
  return null;
}
